import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  const areas = t('footer.areas', { returnObjects: true }) as string[];

  return (
    <footer className="bg-[#2C3E50] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-4 gap-12 mb-16">
          <div className="col-span-2">
            <h3 className="text-2xl font-bold mb-4">ARIEIRA ARAUJO ADVOGADOS</h3>
            <p className="text-sm text-gray-300 leading-relaxed mb-4">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-3 text-sm text-gray-400">
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                {t('footer.location')}
              </span>
            </div>
            <a 
              href="https://wa.me/5521998029019" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center gap-2 mt-4 text-sm text-white bg-green-600 hover:bg-green-700 transition-colors px-4 py-2 rounded-md cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              +55 21 99802-9019
            </a>
          </div>
          
          <div>
            <p className="text-xs font-semibold text-gray-400 tracking-widest uppercase mb-4">
              {t('footer.quickLinks')}
            </p>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-sm text-white hover:text-amber-400 transition-colors cursor-pointer">{t('nav.about')}</a>
              </li>
              <li>
                <a href="#partners" className="text-sm text-white hover:text-amber-400 transition-colors cursor-pointer">{t('nav.partners')}</a>
              </li>
              <li>
                <a href="#practice" className="text-sm text-white hover:text-amber-400 transition-colors cursor-pointer">{t('nav.practice')}</a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-white hover:text-amber-400 transition-colors cursor-pointer">{t('nav.contact')}</a>
              </li>
            </ul>
          </div>
          
          <div>
            <p className="text-xs font-semibold text-gray-400 tracking-widest uppercase mb-4">
              {t('footer.practiceAreas')}
            </p>
            <ul className="space-y-3">
              {areas.map((area, index) => (
                <li key={index} className="text-sm text-gray-300">{area}</li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-600 pt-8 pb-8">
          <div className="max-w-5xl mx-auto mb-8">
            <p className="text-xs text-gray-400 leading-relaxed text-center">
              {t('footer.disclaimer')}
            </p>
          </div>
          
          <div className="text-center">
            <h2 className="text-6xl font-bold text-amber-600/20 tracking-wider mb-6">
              ARIEIRA ARAUJO
            </h2>
            <div className="flex items-center justify-center gap-8 text-sm text-gray-400">
              <p>&copy; {t('footer.copyright')}</p>
              <span>|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
                {t('footer.poweredBy')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
